import React from "react";
import "../styles/ServicesCarousel.css";

import carWash from "../images/services/cw.jpg";
import carpet from "../images/services/carpet.png";
import water from "../images/services/wr1.jpg";
import barber from "../images/services/barber.png";
import cafe from "../images/services/coffee.jpg";

const services = [
  {
    title: "Car Wash",
    image: carWash,
    desc: "Professional interior and exterior cleaning to keep your car spotless and fresh every time.",
  },
  {
    title: "Carpet Cleaning",
    image: carpet,
    desc: "Deep carpet cleaning with same-day pick-up and delivery, stain removal and long-lasting freshness.",  },
  {
    title: "Water Refill",
    image: water,
    desc: "Clean, safe water delivered to your doorstep quickly and conveniently.",
  },
  {
    title: "Barber Shop",
    image: barber,
    desc: "Sharp cuts and grooming services from experienced barbers for a clean, confident look.",
  },
  {
    title: "Cafe",
    image: cafe,
    desc: "Enjoy fresh coffee and snacks in a relaxing and comfortable environment.",
  },
];

const ServicesCarousel = () => {
  return (
    <section className="services-carousel-section">
      <div className="services-carousel">
        {services.map((service, index) => (
          <div className="service-card" key={index}>
            <img src={service.image} alt={service.title} />

            <div className="service-content">
              <h3>{service.title}</h3>
              <p className="service-desc">{service.desc}</p>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
};

export default ServicesCarousel;